import { Fragment } from 'react'
import PropTypes from 'prop-types'

import Button from 'components/common/Button'
import theme from 'theme'
import Modal, {
  ModalHeader,
  ModalCloseButton,
  ModalTitle,
  ModalSubtitle
} from 'components/Modal'
import Text from 'components/common/Text'

export function ModalFooterSection(props) {
  const {
    cancelText,
    cancelButtonProps,
    confirmText,
    confirmButtonProps,
    cancelButtonType,
    confirmButtonType,
    loading,
    onCancel,
    disabled,
    onConfirm,
    footerDescription,
    hideFooterSeparator
  } = props
  return (
    <Fragment>
      {!hideFooterSeparator && (
        <div
          css={{
            marginTop: theme.space[3],
            marginBottom: theme.space[3],
            height: 1,
            backgroundColor: theme.colors.gray[1]
          }}
        />
      )}
      {footerDescription}

      <section
        css={{
          display: 'grid',
          gap: theme.space[3],
          gridTemplateColumns: cancelText === false ? '1fr' : '1fr 1fr'
        }}
      >
        {cancelText !== false && (
          <Button
            data-change-state-button={cancelText}
            disabled={disabled}
            onClick={onCancel}
            {...{ [cancelButtonType]: true }}
            {...cancelButtonProps}
          >
            {cancelText}
          </Button>
        )}
        {confirmText !== false && (
          <Button
            data-change-confirm-button={confirmText}
            disabled={disabled}
            loading={loading}
            onClick={onConfirm}
            {...{ [confirmButtonType]: true }}
            {...confirmButtonProps}
          >
            {confirmText}
          </Button>
        )}
      </section>
    </Fragment>
  )
}

ModalFooterSection.propTypes = {
  cancelText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  cancelButtonProps: PropTypes.object,
  confirmText: PropTypes.string,
  confirmButtonProps: PropTypes.object,
  cancelButtonType: PropTypes.string,
  confirmButtonType: PropTypes.string,
  loading: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  disabled: PropTypes.bool,
  confirmationContent: PropTypes.node,
  footerDescription: PropTypes.node,
  hideFooterSeparator: PropTypes.bool
}

ModalFooterSection.defaultProps = {
  cancelText: 'Cancel',
  confirmText: 'Yes',
  cancelButtonType: 'secondary',
  confirmButtonType: 'destructive',
  hideFooterSeparator: false,
  disabled: false,
  loading: false,
  onCancel: () => {},
  onConfirm: () => {},
  footerDescription: null
}

export default function ConfirmationModal(props) {
  const {
    open,
    title,
    subtitle,
    message,
    onCancel,
    className,
    hideFooter,
    hideOverlay,
    shouldCloseOnOverlayClick
  } = props

  return (
    <Modal
      data-test-confirmation-modal-name
      className={className}
      css={{ width: '32em' }}
      isOpen={open}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      style={{
        overlay: {
          backgroundColor: hideOverlay ? 'transparent' : 'rgba(0,0,0,0.3)'
        }
      }}
      onRequestClose={onCancel}
    >
      <ModalHeader>
        <ModalCloseButton onClick={() => onCancel({ discardModal: true })} />
        <ModalTitle>{title}</ModalTitle>
        {subtitle && <ModalSubtitle>{subtitle}</ModalSubtitle>}
      </ModalHeader>
      <div
        css={{
          marginTop: subtitle ? 0 : theme.space[3],
          textAlign: 'center'
        }}
      >
        {typeof message === 'string' ? (
          <Text
            as="p"
            css={{
              textAlign: 'center'
            }}
          >
            {message}
          </Text>
        ) : (
          message
        )}
      </div>
      {!hideFooter && <ModalFooterSection {...props} />}
    </Modal>
  )
}

ConfirmationModal.propTypes = {
  open: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  message: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.node
  ]),
  confirmText: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  className: PropTypes.string,
  hideFooter: PropTypes.bool,
  hideOverlay: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
  footerDescription: PropTypes.node
}

ConfirmationModal.defaultProps = {
  onCancel: () => {},
  hideOverlay: false,
  shouldCloseOnOverlayClick: true,
  footerDescription: null
}
